// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"9c3e9fac","693":"0746dfc9","983":"1440bcd9"}[chunkId] + ".chunk.js";
};